// eslint-disable-next-line no-unused-vars
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

const ShopSuey = {
  noScroll(active = true) {
    const body = document.querySelector("body");
    if (active) {
      body.classList.add("no-scroll");
    } else {
      body.classList.remove("no-scroll");
    }
  },
  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  },
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  },
  setCSSVariable(variable, value) {
    document.documentElement.style.setProperty(variable, value);
  },
  getCSSVariable(variable) {
    getComputedStyle(document.documentElement).getPropertyValue(variable);
  },
};

window.ShopSuey = ShopSuey;

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}
